import { addMonths, differenceInMonths } from 'date-fns';
import { parseIsoDate } from 'ns_libs/formatter';
import { SaleFrequency } from 'views/ProFormaTable/types';

export const getSalesPeriodLabel = (
    period: number,
    frequency: SaleFrequency,
    salesStart: string | null | undefined,
    constructionStart: string | null | undefined,
): string => {
    const prefix = frequency === 'monthly' ? 'M' : 'Q';
    const monthStep = frequency === 'monthly' ? 1 : 3;

    const constructionStartDate = constructionStart ? parseIsoDate(constructionStart) : null;
    const salesStartDate = salesStart ? parseIsoDate(salesStart) : null;
    if (!constructionStartDate || !salesStartDate) return `${prefix}${period}`;

    const firstOption = addMonths(
        new Date(constructionStartDate.getFullYear(), constructionStartDate.getMonth(), 1),
        monthStep,
    );
    const startIndex = Math.floor(differenceInMonths(salesStartDate, firstOption) / monthStep);

    const absoluteIndex = startIndex >= 0 ? startIndex + period : period;
    return `${prefix}${absoluteIndex}`;
};
